import React from 'react';
function MoneyZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Condition</th>
          <th > Résultats</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Obligation de Zakat	</td>
          <td>{result.zakatDuty === 'yes' ? 'Zakat obligatoire' : 'Zakat non obligatoire'}</td>
        </tr>
        <tr >
          <td>Seuil de Zakat sur l'argent</td>
          <td>{result.threshold} </td>
        </tr>
        <tr >
          <td>Montant de Zakat à payer (de l'argent)</td>
          <td>{result.zakat} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default MoneyZakatTable;
